(ns frontend.ui.component.tab-layout.style
  (:require
   [frontend.ui.style.theme.core :refer [color font-weight]]
   [frontend.ui.style.theme.core :as theme]
   [garden.util :refer [space-join]]))

(defn tab-title
  [selected?]
  (merge
   {:padding     "0 16px 8px"
    :display     "inline-block"
    :font-weight (font-weight :semi-bold)}
   (if selected?
     {:color         (theme/color [:tab-layout :tab-title :selected :fg])
      :border-bottom (space-join ["2px solid"
                                  (theme/color [:tab-layout :tab-title :selected :border-bottom])])}
     {:cursor "pointer"})))

(defn header
  []
  {:padding       "16px 0px 0px"
   :display       "flex"
   :align-items   "center"
   :max-width     "1320px"
   :border-bottom (space-join ["1px solid"
                               (theme/color [:tab-layout :tab-title :regular :border-bottom])])
   :margin        "0 auto 16px"})

(defn body
  []
  {:padding "16px"})
